import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';
import { AuthService } from './AuthService';
import { AlertPresenter } from '../AlertBinder';

export class AuthHandler {

    static inject = () => [
        MixPanelEventEmitter,
        AuthService,
        AlertPresenter
    ];
    constructor(
        private mixpanel: MixPanelEventEmitter,
        private authService: AuthService,
        private alert: AlertPresenter
    ) {};

    login = async ({ trackingFrom, returnTo }: { trackingFrom: string, returnTo?: string }) => {
        this.mixpanel.track('Sign In Initiated', () => ({ From: trackingFrom }));
        try {
            await this.authService.login({ returnTo });
        } catch (e: any) {
            if (e.errorCode === 'offline') {
                this.mixpanel.track('Sign In Offline Aborted', () => ({ From: trackingFrom }));
                this.alert.showAlertV2({
                    header: `It looks like you're offline`,
                    message: 'Please try again when you have reliable internet.'
                });
            } else {
                throw e;
            }
        }
    };

    logout = async () => {
        this.mixpanel.track('Signed Out');
        try {
            await this.authService.logout();
        } catch (e: any) {
            if (e.errorCode === 'offline') {
                this.mixpanel.track('Sign Out Offline Aborted');
                this.alert.showAlertV2({
                    header: `It looks like you're offline`,
                    message: 'Please try again when you have reliable internet.'
                });
            } else {
                throw e;
            }
        };
    };
}
